/**
 * Converts markdown formatting to HTML, preserving bold text for titles
 * while removing other markdown patterns for clean display.
 */
export const stripMarkdownFormatting = (text: string): string => {
  if (!text) return text;
  
  let formatted = text
    // Convert headings to bold: ### Heading -> <strong>Heading</strong>
    .replace(/^#{1,6}\s+(.+)$/gm, '<strong>$1</strong>')
    // Remove code blocks: ```code``` -> code
    .replace(/```[\s\S]*?```/g, (match) => {
      return match.replace(/```\w*\n?/g, '').replace(/```/g, '');
    })
    // Remove inline code: `code` -> code
    .replace(/`([^`]+)`/g, '$1')
    // Convert double asterisks (bold) to HTML: **text** -> <strong>text</strong>
    // Use word boundary to ensure we're matching complete ** pairs
    .replace(/\*\*([^\*]+?)\*\*/g, '<strong>$1</strong>')
    // Remove single asterisks (italic): *text* -> text (but not if part of **)
    .replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, '$1')
    // Remove underscores (italic/bold): __text__ or _text_ -> text
    .replace(/_{1,2}(.+?)_{1,2}/g, '$1')
    // Remove unordered list markers: - item or * item -> item
    .replace(/^[\s]*[-*+]\s+/gm, '')
    // Remove ordered list markers: 1. item -> item
    .replace(/^[\s]*\d+\.\s+/gm, '')
    // Remove links: [text](url) -> text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    // Remove blockquotes: > text -> text
    .replace(/^>\s+/gm, '')
    // Remove horizontal rules
    .replace(/^[\s]*[-*_]{3,}[\s]*$/gm, '')
    // Convert newlines to <br> tags
    .replace(/\n/g, '<br>')
    // Clean up extra whitespace
    .replace(/(<br>){3,}/g, '<br><br>');
  
  // Sanitize: only allow <strong> and <br> tags to prevent XSS
  formatted = formatted
    .replace(/<(?!\/?strong(?=>|\s.*>)|\/?br(?=>|\s.*>))\/?.*?>/g, '');
  
  return formatted.trim();
};
